// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1B1P419vWZ_9vrbz0-HVWl","feed-list":"_1422RWrs6UodsSYEWGFvTv"};